import * as React from 'react';

function SvgMoveIcon(props) {
  return (
    <svg
      width={22}
      height={22}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M13.75 17.417L11 20.167l-2.75-2.75" fill="#748CAD" />
      <path
        d="M13.75 17.417L11 20.167l-2.75-2.75M17.416 8.25l2.75 2.75-2.75 2.75M4.583 8.25L1.833 11l2.75 2.75M1.833 11h18.334M8.25 4.583L11 1.833l2.75 2.75M11 1.833v18.334"
        stroke="#748CAD"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default SvgMoveIcon;
